import { ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { storageAvailable } from '../../util/helpers';
var FlyingclubPageComponent = /** @class */ (function () {
    function FlyingclubPageComponent(_route, _router, _meta, _title, _errorHandler) {
        this._route = _route;
        this._router = _router;
        this._meta = _meta;
        this._title = _title;
        this._errorHandler = _errorHandler;
    }
    FlyingclubPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._route.data
            .subscribe(function (data) {
            _this.business = data.business;
            _this._updateMeta(data.business);
        }, function (error) {
            _this._errorHandler.handleError(error);
        });
    };
    FlyingclubPageComponent.prototype._updateMeta = function (business) {
        var title = business.name;
        var airport = this.business.airports[0];
        if (airport) {
            title += " at " + airport.identifier;
        }
        this._title.setTitle(title + " - " + environment.appName);
        this._meta.removeTag('name="description"');
    };
    Object.defineProperty(FlyingclubPageComponent.prototype, "airportIdent", {
        /**
         * Returns the airport identifier to use for the "Back to [airport]" link in the header. If the user navigated to
         * the business page from an airport page, then the referer airport should be used (stored in sessionStorage).
         * Otherwise, this will use the first associated airport for the business. If the business is not associated with
         * any airport, this will return null.
         * @returns {string|null}
         */
        get: function () {
            if (!this.business) {
                return null;
            }
            // Get the associated airports (usually, there is only one, but a business may be associated with multiple
            // airports)
            var associatedAirports = this.business.airports || [];
            // Check if there was an airport set in sessionStorage, and that airport is associated with this business.
            if (storageAvailable('sessionStorage')) {
                var lastAirport_1 = sessionStorage.getItem('lastAirport');
                if (lastAirport_1 && associatedAirports.some(function (airport) { return airport.identifier === lastAirport_1; })) {
                    return lastAirport_1;
                }
            }
            // Otherwise, return the identifier of the first associated airport (or null if there are no associated airports).
            return associatedAirports.length ? associatedAirports[0].identifier : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlyingclubPageComponent.prototype, "searchReturnUrl", {
        /**
         * The Flying Club Finder search results URL to return to, when the user arrived here from a search. It is
         * set by FlyingClubFinderResultsListingComponent.onFlyingClubSelected and cleared whenever an airport page
         * is viewed, so it reflects the freshest navigation source.
         * @returns {string|null}
         */
        get: function () {
            if (!storageAvailable('sessionStorage')) {
                return null;
            }
            return sessionStorage.getItem('flyingClubSearchReturn');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlyingclubPageComponent.prototype, "cameFromSearch", {
        get: function () {
            return !!this.searchReturnUrl;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlyingclubPageComponent.prototype, "backLabel", {
        /**
         * Text for the "Back to ..." link: the originating search when the user came from the Flying Club Finder,
         * otherwise the associated airport (or "Search" when there is none).
         * @returns {string}
         */
        get: function () {
            if (this.cameFromSearch) {
                return 'Search';
            }
            return this.airportIdent ? this.airportIdent : 'Search';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Navigates back to wherever the user came from: the Flying Club Finder results (preserving the query) when
     * that is the origin, otherwise the associated airport page, falling back to a fresh search.
     */
    FlyingclubPageComponent.prototype.goBack = function () {
        var returnUrl = this.searchReturnUrl;
        if (returnUrl) {
            this._router.navigateByUrl(returnUrl);
            return;
        }
        if (this.airportIdent) {
            this._router.navigate(['/airports', this.airportIdent]);
            return;
        }
        this._router.navigate(['/search']);
    };
    return FlyingclubPageComponent;
}());
export { FlyingclubPageComponent };
